import { StyledButton as Button } from "./index.styled";

export default Button;
